import {useHistory, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import CampaignCodeForm from "../../../components/CampaignCode/CampaignCodeForm";
import {toast} from "react-toastify";
import {handleError, normalizeToUTC} from "../../../utils/SharedFunctions";
import {getCampaignCode, updateCampaignCode} from "../../../Api/ApiCalls";

const EditCampaignCodePage = () => {
    const {id} = useParams();
    const history = useHistory();
    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        getCampaignCode(id).then((data) => {
            setInitialValues({
                code: data.code,
                campaign_name: data.name,
                type: data.type,
                expiration_date: new Date(data.expirationDate),
                redeem_before_date: new Date(data.redeemBeforeDate),
            });
        });
    }, [id]);

    const handleUpdate = async (values) => {
        try {
            const requestBody = {
                code: values.code,
                name: values.campaign_name,
                type: values.type,
                expiresAt: normalizeToUTC(values.expiration_date),
                redeemAt: normalizeToUTC(values.redeem_before_date),
            }
            await updateCampaignCode(id, requestBody);
            history.push('/campaign-codes');
            toast.success("Campaign code updated successfully!");
        } catch (err) {
            handleError(err);
        }
    };

    if (!initialValues) return <p>Loading...</p>;

    return (
        <div className="container mt-4">
            <h2 className="mb-4">Update Campaign Code</h2>
            <CampaignCodeForm  initialValues={initialValues}
                               onSubmit={handleUpdate}
                               isEditing={true} />
        </div>
    );
}
export default EditCampaignCodePage;